module.exports = __webpack_public_path__ + "./img/link-img.svg";